import { ContextAction } from '../types';
import type { UserState, UserAction } from './types';

export const userInitial = {};

export const userReducer = (
  state: UserState,
  action: UserAction
): UserState => {
  switch (action.type) {
    case ContextAction.setUser:
      return { ...state, ...action.payload };
    case ContextAction.resetUser:
      return userInitial;
    default:
      return state;
  }
};
